{#if $googleMaps === "allow"}
  <iframe width='100%' height='300' id='mapcanvas' src={url} loading="lazy" allowfullscreen frameborder='0' scrolling='no' marginheight='0' marginwidth='0'>
  </iframe>
  <a class='disallow-google-maps js-link float-right' href='#' on:click={() => {$googleMaps = "disallow";}}>
      { $_("embeds.google-maps.disallow") }
  </a>
{:else}
  <div class='allow-google-maps-container'>
      <div class='vertical-center text-center'>
          <a class='allow-google-maps btn btn-secondary' href="#" on:click={() => {$googleMaps = "allow";}}>
              { $_("embeds.google-maps.allow") }
          </a>
      </div>
  </div>
{/if}


<script lang="ts">
    import { onLocalStorage } from "@/utils/svelte/proxies";
    import { _ } from "@frontend/translations";

    export let url: string;
    const googleMaps = onLocalStorage("allowGoogleMaps");
</script>
